import {
	Checkbox,
	type CheckboxProps,
	FormControl,
	FormControlLabel,
	type FormControlLabelProps,
	type FormControlProps,
	FormHelperText,
} from "@mui/material";
import type React from "react";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";

type Props<TFieldValues extends FieldValues, TName> = {
	name: TName;
	control?: Control<TFieldValues>;
	label?: React.ReactNode;
	formControlProps?: FormControlProps;
	labelProps?: Omit<FormControlLabelProps, "control" | "label">;
	onChange?: (value: boolean | undefined) => void;
} & Omit<CheckboxProps, "checked" | "indeterminate" | "onChange">;

export const FormCheckbox = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	name,
	control,
	label,
	labelProps,
	formControlProps,
	onChange,
	...checkboxProps
}: Props<TFieldValues, TName>) => (
	<Controller
		control={control}
		name={name}
		render={({ field, fieldState }) => (
			<FormControl {...formControlProps}>
				<FormControlLabel
					control={
						<Checkbox
							{...field}
							{...checkboxProps}
							onChange={(e) => {
								field.onChange(e);
								onChange?.(e.target.checked);
							}}
							checked={field.value ?? false}
						/>
					}
					label={label}
					{...labelProps}
				/>
				<FormHelperText error>{fieldState.error?.message}</FormHelperText>
			</FormControl>
		)}
	/>
);
